import React from 'react';
import MainPage from './MainPage';

const Drink = () => {
  return <MainPage tag='DRINKS' title='DRINK_SELECTION' url='/drink-selection'/>;
}

export default Drink;